import React from "react";
import { Col, Row } from "react-bootstrap";
import { MecordColors } from "Constants/Color";
import { formatIndianAmount } from "helpers/formatIndianAmount";

export interface ChallanSplitSummaryValues {
  service: {
    sub_total: number;
    discount_value: number;
    net_value: number;
    gst_value: number;
    total_amount: number;
  };
  accessories: {
    sub_total: number;
    discount_value: number;
    net_value: number;
    gst_value: number;
    total_amount: number;
  };
}

interface ChallanSplitSummaryProps {
  currencySymbol?: string;
  splitSummary: ChallanSplitSummaryValues;
  grandTotal: number;
  isCompositionGst?: boolean;
}

const SummaryRow: React.FC<{
  label: string;
  value: number;
  currencySymbol: string;
  bold?: boolean;
  large?: boolean;
}> = ({ label, value, currencySymbol, bold = false, large = false }) => (
  <Row>
    <Col md={6}>
      <p className={bold ? "fw-bold mb-2" : "mb-2"} style={large ? { fontSize: "1.2rem" } : undefined}>
        <strong>{label}</strong>
      </p>
    </Col>
    <Col md={6} className="text-end">
      <p className={bold ? "fw-bold mb-2" : "mb-2"} style={large ? { fontSize: "1.2rem" } : undefined}>
        {currencySymbol} {formatIndianAmount(value)}
      </p>
    </Col>
  </Row>
);

const ChallanSplitSummary: React.FC<ChallanSplitSummaryProps> = ({
  currencySymbol = "₹",
  splitSummary,
  grandTotal,
  isCompositionGst = false,
}) => {
  const service = splitSummary?.service || {
    sub_total: 0,
    discount_value: 0,
    net_value: 0,
    gst_value: 0,
    total_amount: 0,
  };
  const accessories = splitSummary?.accessories || {
    sub_total: 0,
    discount_value: 0,
    net_value: 0,
    gst_value: 0,
    total_amount: 0,
  };

  return (
    <div
      className="p-3"
      style={{
        backgroundColor: MecordColors.ActiveBackground,
        borderRadius: "10px",
      }}
    >
      <div className="mb-2 fw-semibold" style={{ fontSize: "13px" }}>
        Service
      </div>
      <SummaryRow
        label="Sub Total (Before Discount) :"
        value={service.sub_total}
        currencySymbol={currencySymbol}
      />
      <SummaryRow
        label="Total Discount Value :"
        value={service.discount_value}
        currencySymbol={currencySymbol}
      />
      <SummaryRow
        label="Net Taxable Value :"
        value={service.net_value}
        currencySymbol={currencySymbol}
      />
      {!isCompositionGst && (
        <SummaryRow
          label="Total GST Value :"
          value={service.gst_value}
          currencySymbol={currencySymbol}
        />
      )}

      <hr />
      <div className="mb-2 fw-semibold" style={{ fontSize: "13px" }}>
        Accessories
      </div>
      <SummaryRow
        label="Sub Total (Before Discount) :"
        value={accessories.sub_total}
        currencySymbol={currencySymbol}
      />
      <SummaryRow
        label="Total Discount Value :"
        value={accessories.discount_value}
        currencySymbol={currencySymbol}
      />
      <SummaryRow
        label="Net Taxable Value :"
        value={accessories.net_value}
        currencySymbol={currencySymbol}
      />
      {!isCompositionGst && (
        <SummaryRow
          label="Total GST Value :"
          value={accessories.gst_value}
          currencySymbol={currencySymbol}
        />
      )}

      <hr />
      <SummaryRow
        label="Grand Total Amount :"
        value={grandTotal}
        currencySymbol={currencySymbol}
        bold
        large
      />
    </div>
  );
};

export default ChallanSplitSummary;
